export class ToggleClass {
  constructor(selector, target, activeClass = 'actived', optinalTargets, cb, blockBodyScroll = false) {
    this.elements = document.querySelectorAll(selector);
    this.target = target;
    this.activeClass = activeClass;
    this.optinalTargets = optinalTargets;
    this.cb = cb
    this.blockBodyScroll = blockBodyScroll
    this.initEvents();
  }

  initEvents() {
    Array.prototype.forEach.call(this.elements, el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        el.classList.add(this.activeClass);

        if (this.target.classList.contains(this.activeClass)) {
          el.classList.remove(this.activeClass);
        }

        this.target.classList.toggle(this.activeClass);
        
        if(this.blockBodyScroll)
          document.body.classList.toggle('block-scroll-filters');
        
        if(this.optinalTargets !== undefined && this.optinalTargets !== null) {
          Array.prototype.forEach.call(this.optinalTargets, target => {
            target.classList.toggle(this.activeClass);
          })
        }

        if(this.cb && typeof(this.cb) === "function")
          this.cb(e, this.target.classList.contains(this.activeClass))
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/utils.js